import { render, staticRenderFns } from "./witch_hat.vue?vue&type=template&id=56aa7c16&"
import script from "./witch_hat.vue?vue&type=script&lang=js&"
export * from "./witch_hat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports